import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import { getPredefinedGroupLabel } from "@common/constants/domains/accounting/accountGroups";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CoaMappingRow } from "../coaMappingRowTypes";
import { useCoaMappingCellData } from "./useCoaMappingCellData";

export const CoaMappingTypeCell = memo(
    ({
        row,
        table,
    }: CellContext<ViewTableFeatures, CoaMappingRow, unknown>) => {
        const { account, kickAccount } = useCoaMappingCellData({
            row: row.original,
            table,
        });
        const type = kickAccount?.type ?? account?.kickType ?? null;
        return (
            <ViewTableCell>
                {type !== null ? getPredefinedGroupLabel(type) : null}
            </ViewTableCell>
        );
    },
);

CoaMappingTypeCell.displayName = "CoaMappingTypeCell";
